import { ActionReducerMapBuilder, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { IBusinesses, IBusinessesState, ILibBusiness } from ".";

export interface IGetLibBusinessesResponse {
    lib: ILibBusiness[];
    businesses: IBusinesses[];
}

export const getBusinesses = createAsyncThunk<IGetLibBusinessesResponse>(
    'getBusinesses',
    async () => await api.businesses.getLib()
);

const getBusinessesHandler = (builder: ActionReducerMapBuilder<IBusinessesState>) => {
    builder
        .addCase(getBusinesses.pending, (state: IBusinessesState) => {
            state.loading = true;
            state.error = "";
        })
        .addCase(getBusinesses.fulfilled, (state: IBusinessesState, action: PayloadAction<IGetLibBusinessesResponse>) => {
            state.loading = false;
            if (!action.payload)
                return;

            state.lib = action.payload.lib;
            state.businesses = action.payload.businesses;
            state.activeBusiness = state.businesses.length ? state.businesses[0] : null;

            if (state.activeBusiness)
                state.activeBusiness.elements.sort((a, b) => a.type - b.type);
        })
        .addCase(getBusinesses.rejected, (state: IBusinessesState) => {
            state.loading = false;
            state.error = 'Unable to get businesses info';
        });
};

export default getBusinessesHandler;